/** Iconos line para toasts de flujo (sin emoji Unicode). */
export function FlowToastGlyph({ kind }: { kind: 'success' | 'error' | 'info' }) {
  const common = {
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true as const,
  };
  if (kind === 'error') {
    return (
      <svg {...common}>
        <circle cx={12} cy={12} r={10} />
        <path d="M12 8v5M12 16h.01" />
      </svg>
    );
  }
  if (kind === 'info') {
    return (
      <svg {...common}>
        <circle cx={12} cy={12} r={10} />
        <path d="M12 16v-5M12 8h.01" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}
